var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.183594 -0.015625 C 11.71875 -0.015625 12.253906 -0.015625 12.789062 -0.015625 C 15.320312 0.078125 17.757812 0.601562 20.109375 1.550781 C 20.730469 1.8125 21.324219 2.117188 21.890625 2.46875 C 23.222656 6.898438 23.175781 11.316406 21.746094 15.71875 C 19.871094 14.277344 17.777344 13.292969 15.460938 12.761719 C 15.226562 12.441406 15.015625 12.105469 14.828125 11.757812 C 17.148438 12.121094 19.285156 12.953125 21.242188 14.253906 C 22.214844 10.511719 22.175781 6.777344 21.128906 3.058594 C 19.109375 1.988281 16.960938 1.324219 14.683594 1.0625 C 11.273438 0.636719 7.953125 1.011719 4.722656 2.183594 C 4.078125 2.429688 3.449219 2.722656 2.84375 3.058594 C 1.796875 6.777344 1.757812 10.511719 2.726562 14.253906 C 4.683594 12.953125 6.824219 12.121094 9.144531 11.757812 C 8.953125 12.105469 8.742188 12.441406 8.511719 12.761719 C 6.195312 13.292969 4.097656 14.277344 2.226562 15.71875 C 0.796875 11.316406 0.75 6.898438 2.082031 2.46875 C 2.648438 2.117188 3.242188 1.8125 3.859375 1.550781 C 6.210938 0.601562 8.652344 0.078125 11.183594 -0.015625 Z M 11.183594 -0.015625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.964706,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.53125 23.984375 C 12.464844 23.984375 12.398438 23.984375 12.332031 23.984375 C 12.203125 23.929688 12.121094 23.835938 12.085938 23.699219 C 12.0625 22.425781 12.066406 21.152344 12.101562 19.878906 C 12.253906 20.347656 12.429688 20.808594 12.632812 21.257812 C 12.640625 21.832031 12.652344 22.40625 12.660156 22.980469 C 13.113281 22.566406 13.625 22.242188 14.195312 22.003906 C 13.378906 21.089844 12.707031 20.074219 12.171875 18.960938 C 12.121094 18.832031 12.089844 18.699219 12.085938 18.558594 C 12.0625 18.082031 12.066406 17.601562 12.101562 17.125 C 12.632812 18.886719 13.523438 20.4375 14.769531 21.773438 C 15.347656 21.554688 15.914062 21.300781 16.464844 21.015625 C 14.535156 19.726562 13.097656 18.027344 12.144531 15.917969 C 12.113281 15.796875 12.09375 15.671875 12.085938 15.546875 C 12.0625 15.09375 12.066406 14.644531 12.101562 14.195312 C 12.933594 16.96875 14.566406 19.128906 16.996094 20.683594 C 17.535156 20.332031 18.007812 19.898438 18.417969 19.390625 C 15.589844 18.15625 13.507812 16.148438 12.171875 13.363281 C 12.121094 13.234375 12.089844 13.101562 12.085938 12.960938 C 12.0625 12.484375 12.066406 12.003906 12.101562 11.527344 C 13.101562 14.753906 15.113281 17.121094 18.128906 18.632812 C 18.335938 18.730469 18.546875 18.820312 18.761719 18.90625 C 18.867188 18.792969 18.957031 18.667969 19.035156 18.53125 C 19.171875 18.285156 19.300781 18.039062 19.421875 17.785156 C 17.429688 17.023438 15.800781 15.789062 14.527344 14.082031 C 13.820312 13.148438 13.246094 12.132812 12.804688 11.039062 C 12.378906 9.839844 12.148438 8.605469 12.113281 7.335938 C 12.078125 6.320312 12.066406 5.304688 12.070312 4.292969 C 12.015625 4.292969 11.957031 4.292969 11.898438 4.292969 C 11.90625 6.722656 11.898438 9.152344 11.886719 11.582031 C 10.96875 14.527344 9.1875 16.769531 6.53125 18.316406 C 5.960938 18.628906 5.367188 18.898438 4.75 19.121094 C 4.714844 19.140625 4.675781 19.140625 4.636719 19.121094 C 4.277344 18.578125 3.988281 18 3.773438 17.382812 C 5.46875 16.910156 6.917969 16.039062 8.125 14.769531 C 9.230469 13.59375 10.074219 12.246094 10.652344 10.722656 C 11.09375 9.378906 11.3125 8.003906 11.3125 6.589844 C 11.324219 5.632812 11.332031 4.675781 11.324219 3.71875 C 11.765625 3.71875 12.207031 3.71875 12.644531 3.71875 C 12.628906 5.046875 12.652344 6.378906 12.71875 7.707031 C 12.839844 9.800781 13.511719 11.695312 14.726562 13.390625 C 15.664062 14.730469 16.835938 15.804688 18.242188 16.621094 C 18.863281 16.957031 19.515625 17.210938 20.195312 17.382812 C 19.53125 19.269531 18.316406 20.683594 16.550781 21.617188 C 15.804688 21.964844 15.046875 22.292969 14.28125 22.59375 C 13.875 22.773438 13.503906 23.003906 13.164062 23.28125 C 13.003906 23.441406 12.863281 23.621094 12.746094 23.8125 C 12.683594 23.890625 12.613281 23.945312 12.53125 23.984375 Z M 12.53125 23.984375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.84375 13.105469 C 11.9375 13.765625 11.867188 14.414062 11.625 15.058594 C 10.601562 17.652344 8.878906 19.644531 6.460938 21.027344 C 5.925781 20.660156 5.457031 20.21875 5.050781 19.707031 C 5.015625 19.664062 4.996094 19.617188 4.996094 19.566406 C 8.175781 18.359375 10.457031 16.207031 11.84375 13.105469 Z M 11.84375 13.105469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.84375 15.773438 C 11.933594 16.40625 11.902344 17.035156 11.742188 17.667969 C 11.128906 19.410156 10.15625 20.917969 8.828125 22.191406 C 8.808594 22.195312 8.789062 22.199219 8.769531 22.207031 C 8.144531 21.96875 7.542969 21.6875 6.960938 21.359375 C 6.921875 21.339844 6.921875 21.320312 6.960938 21.300781 C 9.183594 19.984375 10.8125 18.140625 11.84375 15.773438 Z M 11.84375 15.773438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.84375 18.703125 C 11.9375 19.328125 11.886719 19.953125 11.683594 20.570312 C 11.355469 21.429688 10.929688 22.234375 10.40625 22.980469 C 10.054688 22.769531 9.691406 22.585938 9.316406 22.421875 C 10.402344 21.347656 11.246094 20.109375 11.84375 18.703125 Z M 11.84375 18.703125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.937255,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.640625 23.984375 C 11.574219 23.984375 11.507812 23.984375 11.441406 23.984375 C 11.359375 23.945312 11.285156 23.890625 11.226562 23.8125 C 11.113281 23.621094 10.972656 23.449219 10.808594 23.296875 C 11.21875 22.695312 11.578125 22.066406 11.886719 21.402344 C 11.90625 22.167969 11.90625 22.933594 11.886719 23.699219 C 11.847656 23.835938 11.769531 23.929688 11.640625 23.984375 Z M 11.640625 23.984375 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosvg);
export default __webpack_public_path__ + "static/media/logosvg.62a4039e6c64819a76586e5ae62e18ba.svg";
export { ForwardRef as ReactComponent };